import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DashboardContainer, VimeoIcon, VIMEO_ICON_TYPE } from "../../../funcs/utils";
import { Bar } from "react-chartjs-2";
import { CategoryScale, Chart, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const RMD_VIDEO_ID = "653227471";
const VIMEO_0 = "788100029";

class IRAMinimumDistribution_ extends Component {
  constructor() {
    super();
    this.state = {
      ira: 500000,
      ror: 9,
      show_video: false,
      chartData: null,
      tableData: []
    };
  }

  componentDidMount() {
    this.calculateAndSetData();
  }

  calculateAndSetData = () => {
    const { ira, ror } = this.state;

    var array = [25.6, 24.7, 23.8, 22.9, 22.0, 21.1, 20.3, 19.5, 18.7, 17.9, 17.1, 16.3, 15.5, 14.8, 14.1, 13.4, 12.7, 12.0, 11.4, 10.8, 10.2, 9.6, 9.1, 8.6, 8.1, 7.6, 7.1, 6.7, 6.3, 5.9, 5.5, 5.2, 4.9, 4.5, 4.2, 3.9, 3.7, 3.4, 3.1, 2.9, 2.6, 2.4, 2.1, 1.9];
    var array2 = [72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115];
    var array3 = [43, 42, 41, 40, 39, 38, 37, 36, 35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0];

    let iraValueCalc = ira;
    let rateOfReturn = ror / 100;

    let acctsize = [];
    let rmd = [];

    for (var i = 0; i < array.length; i++) {
      if (i === 0) {
        acctsize.push(iraValueCalc);
      } else {
        iraValueCalc = ((acctsize[i-1]-rmd[i-1])*rateOfReturn+(acctsize[i-1]-rmd[i-1]));
        acctsize.push(iraValueCalc);
      }
      rmd.push(iraValueCalc / array[i]);
    }

    acctsize = this.round(acctsize);
    rmd = this.round(rmd);

    var chartData = {
      labels: array2,
      datasets: [
        {
          label: 'Account size',
          data: acctsize,
          backgroundColor: '#e9ecef',
          stack: '1',
        },
        {
          label: 'RMD',
          data: rmd,
          backgroundColor: '#212529',
          stack: '1',
        }
      ]
    };

    var tableData = array2.map((age, index) => ({
      age,
      yearsLeft: array3[index],
      accountSize: acctsize[index].toLocaleString(),
      rmd: rmd[index].toLocaleString(),
    }));

    this.setState({ chartData, tableData });
  }

  round = (value) => {
    var array = [];
    for (var i = 0; i < value.length; i++) {
        array.push(Math.round(value[i]*100)/100);
    }
    return array;
  }

  handleInputChange = (event) => {
    const { id, value } = event.target;
    this.setState({
      [id]: value
    }, () => {
      this.calculateAndSetData();
    });
  }

  dump_video = (icon, video_id, label) => {
    var span_style = {
      paddingLeft: "1rem",
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <VimeoIcon
          state={this.state}
          component={this}
          icon={icon}
          video_id={video_id}
          id={"vimeo_" + video_id}
        />
        <span style={span_style}>{label}</span>
      </div>
    )
  }

  create_chart = () => {
    const { chartData, tableData, ira, ror } = this.state;

    var input_group_style = {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'stretch',
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    }

    var input_group_text_style = {
      display: 'flex',
      alignItems: 'center',
      padding: '.375rem .75rem',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
      color: '#212529',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      borderRadius: '.25rem'
    }

    var input_group_1_style = {
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0',
    }

    var input_group_2_style = {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
    }

    var input_style = {
      boxShadow: 'none',
      display: 'block',
      padding: '.375rem .75rem',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
      color: '#212529',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
      border: '1px solid #ced4da',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      borderRadius: '.25rem'
    }

    var input_style_1 = {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0'
    }

    var input_style_2 = {
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0'
    }

    return (
      <div>
        <p style={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '1rem' }}>This calculator should be used by unmarried owners, married owners whose spouses aren't more than 10 years younger, and married owners whose spouses aren't the sole beneficiaries of their IRAs</p>
        <div className='ira_calculator_container' style={{ display: 'flex' }}>
          <div className='inputs' style={{ width: '20%' }}>
            <div>
              <label htmlFor="ira" style={{ fontWeight: 'bold' }} className="form-label">Value of IRA at 72</label>
              <div style={input_group_style}>
                <span style={{...input_group_text_style, ...input_group_1_style}}>$</span>
                <input
                  type="text"
                  id="ira"
                  value={ira}
                  onChange={this.handleInputChange}
                  style={{...input_style, ...input_style_1}}
                />
              </div>
            </div>
            <div>
              <label htmlFor="ror" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }} className="form-label">Estimated Rate of Return</label>
              <div style={input_group_style}>
                <input
                  type="text"
                  id="ror"
                  value={ror}
                  onChange={this.handleInputChange}
                  style={{...input_style, ...input_style_2}}
                />
                <span style={{...input_group_text_style, ...input_group_2_style}}>%</span>
              </div>
            </div>
          </div>
          { chartData && <div className='bar_chart' style={{ width: '50%', paddingLeft: '0.75rem', paddingRight: '0.75rem' }}>
            <Bar
              data={chartData}
              options={{
                animation: false,
                plugins: {
                  legend: {
                      display: true,
                      position:'bottom',
                  }
                },
                scales: {
                  y: {
                      beginAtZero: true
                  }
                },
                aspectRatio: 1|1
              }}
            />
          </div> }
          { chartData && 
              <div style={{width: '30%'}}>
                <table className="table table-sm" style={{ fontSize: '10px', width:' 100%' }}>
                  <thead>
                    <tr>
                      <th>Age</th>
                      <th>Years left</th>
                      <th>Account Size</th>
                      <th>RMD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.age}</td>
                        <td>{row.yearsLeft}</td>
                        <td>${row.accountSize}</td>
                        <td>${row.rmd}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> }
        </div>
        <div>
          <h5 style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>Distribution Rules</h5>
          <ol style={{ paddingLeft: '2rem' }}>
              <li>If you have more than one IRA, you must figure the required distribution separatly for each IRA.</li>
              <li>Use the appropriate life expectancy or distribution period for each year and for each IRA.</li>
              <li>if you have more than one IRA, you must withdraw an amount equal to the total of the required distributions figured for each IRA. You can, however withdraw the total from one IRA or from more than one IRA.</li>
          </ol>
        </div>
      </div>
    );
  }

  render() {
    return (
      <DashboardContainer
        title={"Required Minimum Distributions"}
        client={this.props.client}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
          <div>
            {this.dump_video(VIMEO_ICON_TYPE.AVATAR, VIMEO_0, "About this calculator")}
            {this.dump_video(VIMEO_ICON_TYPE.PRIMER, RMD_VIDEO_ID, "Learn more RMDs")}
          </div>
        </div>
        {this.create_chart()}
      </DashboardContainer>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
}

const mapStateToProps = state => {
  return {
    client: state.client,
  };
}

const IRAMinimumDistribution = connect(mapStateToProps, mapDispatchToProps)(IRAMinimumDistribution_);

export { IRAMinimumDistribution };
